import { EntityRequestLoa } from "../../entity/EntityRequestLoa";

export class DtoRequestLoasDeleteRes extends EntityRequestLoa {
  public message: string | null = null;
}
